import type { Meta, StoryObj } from '@storybook/react'
import Box from '@mui/material/Box'
import { useState } from 'react'
import StatusFilterButton from './StatusFilterButton'
import { DISPLAYED_LEAD_STATUSES } from './LeadCountRow'


const counts: Record<string, number> = {
  'new-lead': 106,
  applied: 387,
  enrolled: 83,
  started: 56,
  filtered: 70,
  returned: 31,
  rejected: 50,
  error: 3,
}

const meta: Meta<typeof StatusFilterButton> = {
  title: 'Components/StatusFilterButton',
  component: StatusFilterButton,
  args: {
    status: 'new-lead',
    count: 106,
    selected: false,
  },
}

export default meta

type Story = StoryObj<typeof StatusFilterButton>

export const Default: Story = {}

export const Selected: Story = {
  args: {
    selected: true,
  },
}

export const WithoutCount: Story = {
  args: {
    status: 'new-lead',
    count: 106,
    showCount: false,
  },
}

export const AllStatuses: Story = {
  render: () => (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', p: 2 }}>
      {DISPLAYED_LEAD_STATUSES.map((status) => (
        <StatusFilterButton
          key={status}
          status={status}
          count={counts[status]}
        />
      ))}
    </Box>
  ),
}

export const ToggleExample: Story = {
  render: () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [selectedStatuses, setSelectedStatuses] = useState<string[]>([
      'new-lead',
      'applied',
    ])

    const toggleStatus = (status: string) => {
      setSelectedStatuses((current) =>
        current.includes(status)
          ? current.filter((item) => item !== status)
          : [...current, status]
      )
    }

    return (
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', p: 2 }}>
        {DISPLAYED_LEAD_STATUSES.map((status) => (
          <StatusFilterButton
            key={status}
            status={status}
            count={counts[status]}
            selected={selectedStatuses.includes(status)}
            onClick={() => toggleStatus(status)}
          />
        ))}
      </Box>
    )
  },
}
